<template>
  <div id="app">
    <!-- <Header /> -->
    <router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {
  }
}
</script>
<style>
@font-face {
    font-family: 'robotoregular';
    src: url('/assets/fonts/roboto/Roboto-Regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'robotobold';
    src: url('/assets/fonts/roboto/Roboto-Bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'robotomedium';
    src: url('/assets/fonts/roboto/Roboto-Medium-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'adelleregular';
    src: url('/assets/fonts/Adelle/Adelle_Reg.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'adellebold';
    src: url('/assets/fonts/Adelle/Adelle_Bold.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
}

body {
  background-color: #2e368b;
}
#app {
  font-family: 'robotoregular', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  background-color: #2e368b;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 80px;
  z-index: 999;
  background-color: #2e368b;
}
  .header .sensors {
    position: absolute;
    padding: 5px;
    height: 60px;
    width: 100%;
    top: 10px;
    /* align-items: center; */
  }
  .header .sensors img {
    height: 45px;
    width: auto;
    margin-right: 0;
  }
  .header .buttonboard {
    position: absolute;
    right: 5%;
    top: 20px;
    width: auto;
    height: 45px;
  }
  .header .divider {
    width: 100%;
    position: absolute;
    top: 70px;
  }
  .header .divider hr {
    /* margin-top: 5px; */
    width: 90%;
  }
</style>
